import React, { useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import { getAddFamilyMemberAvailability } from '../../../User/Services/UserFamily.service';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../BaseModule/Components/Text';
import FullPageLoading from '../../../BaseModule/Components/FullPageLoading';
import styles from './AddFamilyMember.module.scss';

const AddFamilyMember: React.FC = () => {
	const { userData } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const [availability, setAvailability] = useState<{
		children: boolean;
		adults: boolean;
	}>({ children: false, adults: false });

	useEffectAsync(async () => {
		const { data } = await getAddFamilyMemberAvailability(userData.id);
		if (data) {
			setAvailability(data);
		}
	}, []);

	const handleAddChildren = () => {
		setIsLoading(true);
		// @ts-ignore
		window.location.href = '/moje-rodina-pridat-dite';
	};

	const handleAddAdult = () => {
		setIsLoading(true);
		// @ts-ignore
		window.location.href = '/moje-rodina-pridat-dospeleho';
	};

	return (
		<div className={styles.wrapper}>
			{availability.children && (
				<div
					className='meddi-btn button-list__btn theme-black mb-3'
					onClick={handleAddChildren}
				>
					<img
						src='/dist/patientV3/icons/addChild.svg'
						alt='icon'
						className='size-45 button-list__btn__icon'
					/>
					<div className='button-list__btn__content'>
						<Text
							className='button-list__btn__content__title'
							tx='base.addChildUpTo18'
							firstUpper
						/>
					</div>
					<div className='button-list__btn__arrow'>
						<img
							src='/dist/patientV3/icons/arrow-right-purple-small.svg'
							alt='arrow-right-purple'
						/>
					</div>
				</div>
			)}
			{availability.adults && (
				<div
					className='meddi-btn button-list__btn theme-black mb-3'
					onClick={handleAddAdult}
				>
					<img
						src='/dist/patientV3/icons/addAdult.svg'
						alt='icon'
						className='size-45 button-list__btn__icon'
					/>
					<div className='button-list__btn__content'>
						<Text
							className='button-list__btn__content__title'
							tx='base.addAdult'
							firstUpper
						/>
					</div>
					<div className='button-list__btn__arrow'>
						<img
							src='/dist/patientV3/icons/arrow-right-purple-small.svg'
							alt='arrow-right-purple'
						/>
					</div>
				</div>
			)}
			{isLoading && <FullPageLoading />}
		</div>
	);
};

export default AddFamilyMember;
